import { notFound } from 'next/navigation'
import { type FC } from 'react'
import { useStats } from 'react-instantsearch'

/**
 * Based on specific cases show 404 instead of search results
 */
export const StoryblokAlgoliaSearchNotFound: FC = () => {
  const { nbPages, page } = useStats()

  if (
    /**
     * Only check when page has results, `0` could mean results are loading.
     * In case of categories we have `all-from-category` link that points to exact same component.
     * During client-side navigation search is initialized on the client side and start search request,
     * during the request there are no results and pages.
     */
    nbPages > 0 &&
    // Current page is out of range (`page` is index based)
    (page < 0 || page >= nbPages)
  ) {
    notFound()
  }

  return null
}
